import { EditorStarterItem } from '../../items/item-type';
import { isTitleTextItem, TextItem } from '../../items/text/text-item-type';
import { syncEditedTitleToStore } from './caption-translation-actions';
import { editAndRelayoutText } from './edit-and-relayout-text';

export const editTextAction = ({
  item,
  editText,
}: {
  item: EditorStarterItem;
  editText: string;
}): TextItem => {
  if (item.type !== 'text') {
    throw new Error('Item is not a text item');
  }

  const editsTranslatedTitle =
    isTitleTextItem(item) && item.translatedTitle !== undefined;
  const nextSegments = editsTranslatedTitle ? undefined : item.segments;
  const segmentsPatch = editsTranslatedTitle ? { segments: undefined } : {};

  if (!item.resizeOnEdit) {
    return {
      ...(item as TextItem),
      text: editText,
      ...segmentsPatch,
      ...syncEditedTitleToStore(item, editText, nextSegments),
    };
  }

  return editAndRelayoutText(item, () => {
    return {
      ...item,
      text: editText,
      ...segmentsPatch,
      ...syncEditedTitleToStore(item, editText, nextSegments),
    };
  });
};
